// extracted by mini-css-extract-plugin
export default {"zoomControls":"saa-z","zoomControlButton":"taa-z","zoomBanner":"uaa-z","bannerButton":"vaa-z","imageButton":"waa-z","zoom":"xaa-z","zoomContent":"yaa-z"};